import React from 'react';
import { Typography, Tooltip, Flex, Progress, Button } from 'antd';
import { useModel, useNavigate, useSelector } from '@umijs/max';
import BoltIcon from '../Icons/bolt';
import { useMediaQuery } from 'react-responsive';

const { Text } = Typography;

const HeaderCreditsMeter = () => {
    const { subscription, people_credits_remaining, product_credits_remaining } = useSelector((state: any) => state.subscription)

    const { initialState } = useModel('@@initialState');
    const currentUser = initialState?.currentUser;
    
    const navigate = useNavigate();
    const isFreeUser = subscription?.name === 'Free';

    // Responsive breakpoint for tablet mode
    const isTabletOrMobile = useMediaQuery({ maxWidth: 968 });

    if (!subscription) return null;

    // Calculate percentages for progress bars
    const peopleCreditsMax = subscription?.subscriptionFeatures.find((feature: any) => feature.feature.key === 'people_credits')?.value || 0;
    const productCreditsMax = subscription?.subscriptionFeatures.find((feature: any) => feature.feature.key === 'product_credits' && (currentUser?.user_type === "packaging" && subscription?.name == "Starter" ? feature.id == 45 : feature.id != 45))?.value || 0;

    const peopleCreditsPercentage = (people_credits_remaining / peopleCreditsMax) * 100;
    const productCreditsPercentage = (product_credits_remaining / productCreditsMax) * 100;

    return (
        <Flex align="center" gap={12} onClick={() => navigate('/pricing')} style={{ cursor: 'pointer' }}>
            <Flex vertical gap={0}>
                <Flex align="center" justify="space-between" style={{ marginBottom: 1 }}>
                    <Text strong style={{ fontSize: '10px', lineHeight: '12px', margin: 0, paddingRight: '10px' }}>People Credits</Text>
                    <Text style={{ fontSize: '10px', lineHeight: '12px', margin: 0 }}>{people_credits_remaining}</Text>
                </Flex>
                <Progress
                    percent={peopleCreditsPercentage}
                    showInfo={false}
                    size="small"
                    strokeColor="#1890ff"
                    trailColor="#f0f0f0"
                    strokeWidth={4}
                    style={{ margin: 0 }}
                />
            </Flex>

            {/* <Flex vertical gap={0}>
                <Flex align="center" justify="space-between" style={{ marginBottom: 1 }}>
                    <Text strong style={{ fontSize: '10px', lineHeight: '12px', margin: 0, paddingRight: '10px' }}>Product Credits</Text>
                    <Text style={{ fontSize: '10px', lineHeight: '12px', margin: 0 }}>{product_credits_remaining}</Text>
                </Flex>
                <Progress
                    percent={productCreditsPercentage}
                    showInfo={false}
                    size="small"
                    strokeColor={productCreditsPercentage < 20 ? 'exception' : '#52c41a'}
                    trailColor="#f0f0f0"
                    strokeWidth={4}
                    style={{ margin: 0 }}
                />
            </Flex> */}

            {isFreeUser && (
                <Button
                    size={"small"}
                    style={{ backgroundColor: '#FFCD00', color: '#000', borderColor: '#FFCD00', fontSize: '10px' }}
                    onClick={() => navigate('/pricing')}
                >
                    {isTabletOrMobile ? 'Upgrade' : 'Upgrade Plan'}
                    <BoltIcon color="#000" />
                </Button>
            )}
        </Flex>
    );
};

export default HeaderCreditsMeter; 